import TabsHeader from 'components/tabs-header';
import { useAccountState } from 'contexts/account/account-context';
import React from 'react';
import { FileText } from 'lucide-react';
import { useIntl } from 'react-intl';

type Props = {
  intro?: React.ReactNode;
  actions?: React.ReactNode;
  utils?: React.ReactNode;
};

const SeaCloudFileUploadTabsHeader: React.FC<Props> = ({ intro, actions, utils }) => {
  const intl = useIntl();
  const { account } = useAccountState();

  return (
    <TabsHeader
      tabs={[
        {
          hasAccess: account.company?.features.hasUploadFilesToSeaCloud,
          label: intl.formatMessage({ id: 'seaCloudFileUpload.navigation.viewFileSummary' }),
          to: '/file-upload',
        },
      ]}
      intro={intro}
      actions={actions}
      utils={utils}
      icon={<FileText size={25} color={'white'} />}
    />
  );
};

export default React.memo(SeaCloudFileUploadTabsHeader);
